import { HTMLAttributes } from 'react';

export const PageSubtitle = ({
  children,
  className,
}: HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <div
      className={`mb-4 md:mb-8 text-left md:text-xl text-base ${className}`}
    >
      {children}
    </div>
  );
};
